export const APP_NAME = '慧得分'
